import { observable, makeAutoObservable } from 'mobx';
import { WelcomeBonusState } from 'src/AppState/WelcomeBonusState/WelcomeBonusState';

export class WelcomeBonusFormState {
    constructor(private readonly welcomeBonusState: WelcomeBonusState) {
        makeAutoObservable(this);
    }
    @observable public startDateError = false;
    @observable public endDateError = false;
    @observable public isUnlimited = false;

    public onChangeEndDate = (date: Date | null): void => {
        if (date !== null) {
            this.welcomeBonusState.date_to.setValue(date.toISOString());
        }
    };

    public onChangeUnlimited = () => {
        this.isUnlimited = !this.isUnlimited;
        this.welcomeBonusState.isUnlimited = this.isUnlimited;
    };

    public onBlurEndDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        if (date.target.value === '') {
            this.endDateError = true;
        } else if (this.endDateError) {
            this.endDateError = false;
        }
    };

    public preventDefault = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
    };
}
